import React from 'react';
// Custom
import { Scrollbars } from 'react-custom-scrollbars';
import { getHocDisplayName } from 'utils/Tools';

const withScroll = (WrappedComponent, scrollOptions = {}) => {
  // Scroll options
  const {
    autoHide = true,
    color = 'default', // 'default', 'light'
  } = scrollOptions;

  // Thumb style
  const thumbStyle = {
    backgroundColor: color === 'light' ? 'rgba(161, 161, 161, .6)' : 'rgba(0, 0, 0, .2)',
    borderRadius: 'inherit',
    zIndex: 3, // To be over sticky headers, whose z-index if 2
  };

  /* eslint-disable react/jsx-props-no-spreading */
  const WithScroll = (props) => (
    <Scrollbars
      style={{ width: '100%', height: '100%', marginTop: '-1px' }}
      autoHide={autoHide}
      renderThumbVertical={({ style, ...sbProps }) => <div {...sbProps} style={{ ...style, ...thumbStyle }} />}
    >
      <WrappedComponent {...props} />
    </Scrollbars>
  );
  /* eslint-enable react/jsx-props-no-spreading */

  WithScroll.displayName = getHocDisplayName('WithScroll', WrappedComponent);

  return WithScroll;
};

export default withScroll;



// WEBPACK FOOTER //
// ./hocs/WithScroll.js